<template>
    <div id="rom_graph">
        <v-chart
            ref="romChart"
            @finished="getChartImage"
            :options="getChartData"
            autoresize
            style="width: 100%;"
        />
    </div>
</template>
<script>
import ECharts from 'vue-echarts'
import {mapActions} from 'vuex';
import {_PART_KEY_RANGE} from "@/components/Table/static";

export default {
  name: 'RomGraphSection',
  components: {
    'v-chart': ECharts
  },
  props: [
    'romChartDataProps',
    'isViewOnlyProps'
  ],
  data() {
    return {
      romChartData: {
        chartData: {},
        requestData: {}
      },
      img: {
        src: '',
        width: 0,
        height: 0
      },
    }
  },
  methods: {
    ...mapActions(['updateRomChartImageData']),
    getChartImage() {
      if (this.isViewOnlyProps) {
        const chart = this.$refs.romChart;
        const {width, height} = chart;
        this.img = {
          src: chart.getDataURL({
            pixelRatio: window.devicePixelRatio * 2 || 1
          }),
          width, height
        }
        this.updateRomChartImageData(this.img);
      }
    }
  },
  computed: {
    getChartData() {
      let maxMin = Math.max.apply(null, this.romChartDataProps?.chartData?.amountOfExercise);

      const chartData = {
        title: {
          text: this.romChartDataProps?.chartData
              ? this.romChartDataProps.chartData.title : '',
          textStyle: {fontSize: '16px'},
          x: 'center'
        },
        grid: {top: '15%'},
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            // dataView: {
            //   show: true,
            //   readOnly: true,
            //   title: this.$t('statistic.raw'),
            //   lang: [this.$t('statistic.raw'), this.$t('statistic.close')],
            //   buttonColor: "rgb(39 92 187)"
            // },
            // magicType: {
            //   show: true,
            //   type: ['line', 'bar'],
            //   title: {line: this.$t('statistic.line'), bar: this.$t('statistic.bar')}
            // },
            // restore: {show: true, title: this.$t('statistic.restore')},
            // saveAsImage: {show: true, title: this.$t('statistic.save_as_image')}
          },
        },
        legend: {
          top: '20px',
          data: ['A ROM', 'P ROM', this.$t('report.total_amount_of_exercise_per_day')]
        },
        xAxis: [
          {
            type: 'category',
            data: this.romChartDataProps?.chartData?.date ?? [],
            axisPointer: {
              type: 'shadow'
            },
            splitLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: 'ROM',
            min: 0,
            max: this.romChartDataProps?.requestData?.position ? _PART_KEY_RANGE.data[this.romChartDataProps.requestData.position].value[this.romChartDataProps.requestData.seqDeviceType].maxRom : _PART_KEY_RANGE.data[0].maxRom,
            interval: 10,
            axisLabel: {
              formatter: '{value} °'
            },
            splitLine: {
              show: false
            }
          },
          {
            type: 'value',
            name: this.$t('report.total_amount_of_exercise_per_day'),
            min: 0,
            max: maxMin < 90 ? 90 : maxMin + 10,
            interval: 10,
            axisLabel: {
              formatter: '{value}' + ' ' + this.$t('unit.min')
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: 'A ROM',
            type: 'bar',
            itemStyle: {normal: {color: '#ffb170'}},
            data: this.romChartDataProps?.chartData?.dataOfArom ?? []
          },
          {
            name: 'P ROM',
            type: 'bar',
            itemStyle: {normal: {color: '#275cbb'}},
            data: this.romChartDataProps?.chartData?.dataOfProm ?? []
          },
          {
            name: this.$t('report.total_amount_of_exercise_per_day'),
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {normal: {color: '#787979'}},
            data: this.romChartDataProps?.chartData?.amountOfExercise ?? []
          }
        ]
      };

      if (this.isViewOnlyProps) {
        chartData.toolbox = {}
        chartData.title = {}
      }
      return chartData
    }
  }
}
</script>
<style lang="scss">
#rom_graph {
  .echarts {
    height: 500px;
    width: 100%;

    h4 {
      background: #fff;
      padding: 10px;
      margin: -5px 20px 10px 20px !important;
    }

    div:first-child {
      width: 55px !important;
    }

    div:last-child {
      div {
        height: 400px !important;

        textarea {
          border: none;
        }
      }

      div:last-child {
        height: 20px !important;
        bottom: 20px !important;

        div {
          padding: 5px 10px;
          font-weight: 700;
          line-height: 1.5;
        }
      }
    }
  }
}
</style>